import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { SortBuilder } from "~/components/SortBuilder"
import { FindStandardsWithCertificateTypesRequestSortsDto } from "~/gen/api"

interface Props {
  sorts: FindStandardsWithCertificateTypesRequestSortsDto
  setSorts: Dispatch<
    SetStateAction<FindStandardsWithCertificateTypesRequestSortsDto>
  >
}

export const StandardSorts = ({ sorts, setSorts }: Props) => {
  const { t } = useTranslation("admin")

  return (
    <SortBuilder<FindStandardsWithCertificateTypesRequestSortsDto>
      sorts={sorts}
      setSorts={setSorts}
      options={[
        {
          label: t("standards.sort.id"),
          value: "id",
        },
        {
          label: t("standards.sort.name"),
          value: "name",
        },
        {
          label: t("standards.sort.certificateTypeCount"),
          value: "certificateTypeCount",
        },
      ]}
    />
  )
}
